// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import DatePicker from 'react-datepicker';

class ExpenseReport extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      revenue_data: [],
      expense_data: [],
      revenue: true,
      expense: false
     
    };
    this.handleSelection = this.handleSelection.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getRevenue() {
    const url = `${getLocationOrigin()}/cm/get_revenue_stats`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({revenue_data:data.result,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  getExpense() {
    const url = `${getLocationOrigin()}/cm/get_expense_stats`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({expense_data:data.result,loading:false})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name
    if(name == 'expense'){
      this.setState({expense:true,revenue:false})
    }
    else if(name == 'revenue'){
      this.setState({revenue:true,expense:false})
    }
  }


  renderExpense(){
    if(this.state.expense_data.length == 0){
      this.getExpense()
    }
    var header = ['Venue','Expense','Target']
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Expense Details</div> 
        <table className="table_plain">
          <tr> 
            { 
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.expense_data && this.state.expense_data.length > 0 ?
              this.state.expense_data.map((data)=>
                <tr>
                 { header.map((index)=>
                    <td>{data[index]}</td>
                    )
                  }
                </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderRevenue(){
    if(this.state.revenue_data.length == 0){
      this.getRevenue()
    }

    var header = ['Venue','Revenue','Target']
    
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Revenue Details</div> 
        <table className="table_plain">
          <tr> 
            {header.map((head)=>
              <th>{head}</th>
            )
          }
          </tr>
          
            { this.state.revenue_data && this.state.revenue_data.length > 0 ?
              this.state.revenue_data.map((data)=>
                <tr>
                 { header.map((index)=>
                    <td>{data[index]}</td>
                    )
                  }
                </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
            }
        </table>
      </div>
      )
  }

  
  render() {
    
    return(
      <div style={styles.container}>
        
          <div className='col-md-12'>
            <div className='col-md-12' style={{padding:'0px'}}>
              <button className='button1' style={{marginRight:'1%'}} onClick={this.handleSelection} name='revenue'> Revenue Details </button>
              <button className='button1' style={{marginRight:'1%'}} onClick={this.handleSelection} name='expense'> Expense Details</button>
              <Link to={`./crud/addExpenseTarget`} >
                <button className='button1' style={{float:'right'}} > Add Target Expense </button>
              </Link>
            </div>
              
            <div className='col-md-12'>
              { this.state.revenue &&
                this.renderRevenue()
              }

              { this.state.expense &&
                this.renderExpense()
              }
            </div>

            
          </div>
        
      </div>
    );
  }
}

export default ExpenseReport;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/expenseReport/ExpenseReport.js